export default __webpack_public_path__ + "static/media/dpWorldTourChampionship-dark.bb4bf50e.svg";